import '../css/Error.css'
import { Link } from 'react-router-dom'

function Error404() {
  return (
    <main id="error_404">
        <div>
            <h1>404</h1>
            <h2>NOT FOUND</h2>
        </div>
        <p>Sorry! Seems we can’t find this page</p>
        <Link to="/" className="btn-primary">Back to home page</Link>
    </main>
  )
}

export default Error404